import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import {BaoyingModule} from './app/baoying.module';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(BaoyingModule)
  .catch(err => console.log(err));
